import Vue from 'vue'
import Router from 'vue-router'

import SignIn from './views/SignIn.vue'

import Home from './views/Home.vue'
import ReturnAuthorisations from './views/ReturnAuthorisations.vue'
import ReturnAuthorisationExpressForm from './views/ReturnAuthorisationExpressForm'
import EditReturn from './views/EditReturn.vue'
import Products from './views/Products.vue'

import Dealers from './views/Dealers.vue'
import AddDealer from './views/AddDealer.vue'
import EditDealer from './views/EditDealer.vue'

import WarrantyRequest from './views/WarrantyRequest'
import DealerLocator from './views/DealerLocator'

import AdminUsers from './views/AdminUsers'
import AddAdminUser from './views/AddAdminUser'
import EditAdminUser from './views/EditAdminUser'

import api from './utils/api.js'
import store from './store'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  routes: [
    { path: '/', name: 'Home', component: Home, meta: { showMenu: false } },
    { path: '/sign-in', name: 'Sign In', component: SignIn, meta: { authNotRequired: true, showMenu: false } },
    { path: '/return-authorisation', name: 'Return Authorisation', component: ReturnAuthorisations },
    { path: '/return-authorisation-express-form', name: 'Return Authorisation Express Form', component: ReturnAuthorisationExpressForm },
    { path: '/edit-return/:id', name: 'Edit Return Authorisation', component: EditReturn },
    { path: '/products', name: 'Products', component: Products },
    { path: '/dealers', name: 'Dealers', component: Dealers },
    { path: '/dealers/add', name: 'Add Dealer', component: AddDealer },
    { path: '/dealers/edit/:id', name: 'Edit Dealer', component: EditDealer },
    { path: '/admin-users', name: 'Admin Users', component: AdminUsers },
    { path: '/admin-users/add', name: 'Add Admin User', component: AddAdminUser },
    { path: '/admin-users/edit/:id', name: 'Edit Admin User', component: EditAdminUser },
    { path: '/warranty-request', name: 'Return Authorisation Form', component: WarrantyRequest, meta: { authNotRequired: true, showMenu: false, showNav: false } },
    { path: '/dealer-locator', name: 'Dealer Locator', component: DealerLocator, meta: { authNotRequired: true, showMenu: false, showNav: false } }
  ]
})

router.beforeEach((to, from, next) => {
  let authRequired = !to.matched.some(record => record.meta.authNotRequired)
  if (!authRequired) {
    next()
    return
  }

  api('checkSession')
    .then(resp => {
      store.dispatch('setUser', resp.name)
      if (resp.msg || authRequired) {
        next()
      } else {
        next('/sign-in')
      }
    })
    .catch(() => {
      store.dispatch('setUser', null)
      if (authRequired) {
        next('/sign-in')
      } else {
        next()
      }
    })
})

export default router
